import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  EventCardInterface,
  FeaturedEventInterface,
  UpcomingEventInterface,
  CategoryInterface,
} from "../../interfaces";

export const publicEventsSlice = createSlice({
  name: "publicEvents",
  initialState: {
    status: "loading",
    categoriesWithEvents: [] as EventCardInterface[],
    upcomingEvents: [] as UpcomingEventInterface[],
    featuredEvents: [] as FeaturedEventInterface[],
    categories: [] as CategoryInterface[],
    eventData: {} as Record<string, any>,
    errorMessage: null as string | null,
  },
  reducers: {
    loadHomePage: (state, { payload }) => {
      state.status = "homePage";
      state.categoriesWithEvents = payload.categoryWithEvents;
      state.upcomingEvents = payload.upcomingEvents;
      state.categories = payload.categories;
      state.featuredEvents = payload.featuredEvents;
      state.eventData = {};
      state.errorMessage = null;
    },
    loadEventPage: (state, { payload }) => {
      state.status = "eventPage";
      state.eventData = payload.eventDataById;
      state.errorMessage = null;
    },
    loadCategoryEvents: (
      state,
      action: PayloadAction<EventCardInterface[]>
    ) => {
      state.categoriesWithEvents = action.payload;
    },
    loadingError: (state, { payload }) => {
      state.status = "loadingError";
      state.categoriesWithEvents = [];
      state.upcomingEvents = [];
      state.featuredEvents = [];
      state.eventData = {};
      state.errorMessage = payload.errorMessage;
    },
    loading: (state) => {
      state.status = "loading";
    },
  },
});

export const {
  loadHomePage,
  loadEventPage,
  loadCategoryEvents,
  loadingError,
  loading,
} = publicEventsSlice.actions;

export default publicEventsSlice.reducer;
